import * as tslib_1 from "tslib";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
let VRadio = class VRadio extends Vue {
    constructor() {
        super(...arguments);
        this.isFocus = false;
    }
    handleStatusChange(state) {
        this.isFocus = state;
    }
    created() {
        this.$nextTick(() => {
            this.$bus.$on("reset-radio-status", (index) => {
                this.isFocus = index === this.index;
            });
        });
    }
    checked() {
        if (this.disabled)
            return;
        this.isFocus = true;
        this.$bus.$emit("get-check-radio", this.index);
    }
};
tslib_1.__decorate([
    Prop({ type: Number, required: true })
], VRadio.prototype, "index", void 0);
tslib_1.__decorate([
    Prop({ type: Boolean, default: false })
], VRadio.prototype, "status", void 0);
tslib_1.__decorate([
    Prop({ type: Boolean, default: false })
], VRadio.prototype, "disabled", void 0);
tslib_1.__decorate([
    Watch('status', { immediate: true })
], VRadio.prototype, "handleStatusChange", null);
VRadio = tslib_1.__decorate([
    Component({
        name: 'VRadio',
    })
], VRadio);
export default VRadio;
